export const i18nSensorsPage = {
  sections: {
    total: 'Total',
    data_health: 'Estados (data health)',
    sensors_data: 'Datos de sensores',
  },
  components: {
    status_table: {
      headers: {
        status: 'Estado',
        description: 'Descripción',
        label: 'Tag/Codigo',
        value: 'Última medición',
        low_low_threshold: 'Lo Lo',
        low_threshold: 'Lo',
        high_threshold: 'Hi',
        high_high_threshold: 'Hi Hi',
        display_threshold: 'Mostrar límites',
      },
      no_value: 'Sin valor',
      edit: 'Editar {{tag}}',
    },
    edit_modal: {
      low_low_threshold: 'Lo Lo',
      low_threshold: 'Lo',
      high_threshold: 'Hi',
      high_high_threshold: 'Hi Hi',
      submit_btn: 'Guardar',
      clear_btn: 'Limpiar',
      details_reason: 'Motivo / Justificación',
    },
    tabs: {
      edit: 'Editar límites',
      history: 'Histórico',
    },
    history: {
      headers: {
        date: 'Fecha / hora',
        low_low_threshold: 'Lo Lo',
        low_threshold: 'Lo',
        high_threshold: 'Hi',
        high_high_threshold: 'Hi Hi',
        reason: 'Detalles / motivo',
        user: 'Usuario',
      },
    },
  },
  message: {
    limit_error: {
      title: 'Ops...',
      message: 'Error al actualizar los límites. Inténtalo de nuevo.',
    },
    limit_success: {
      title: '¡Éxito!',
      message: '¡Límites actualizados con éxito!',
    },
    asset_error: {
      title: 'Ops..',
      message: 'No se pueden cargar los datos del equipo. Espera unos minutos e inténtalo de nuevo',
    },
    sensors_status_error: {
      title: 'Ops..',
      message:
        'No se pueden cargar los datos de los sensores. Espera unos minutos e inténtalo de nuevo',
    },
    no_alarms: {
      title: 'Sin alarmas',
    },
    alarms_error: {
      title: 'Ops..',
      message:
        'No se pueden cargar los datos de la alarma. Espera unos minutos e inténtalo de nuevo',
    },
  },
};
